var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgScrollMore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 44,
  fill: "none",
  viewBox: "0 0 30 44"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E5B021",
  d: "M13.745 42.803a2 2 0 0 0 2.828 0L29.3 30.076a2 2 0 1 0-2.829-2.829L15.16 38.561 3.845 27.247a2 2 0 0 0-2.828 2.829zM13.159.356v41.033h4V.356z"
})));
export default SvgScrollMore;